import { createContext, useState } from 'react';

export const NonBedPdpContext = createContext({});

export const NonBedPdpPageProvider = (props) => {
  const [mainPdpItem, setMainPdpItem] = useState([]);
  const [completeTheLookListingItem, setCompleteTheLookListingItem] = useState([]);
  const [mainPdpItemQuantity, setMainPdpItemQuantity] = useState(1);

  return (
    <NonBedPdpContext.Provider
      value={{
        mainPdpItem,
        setMainPdpItem,
        completeTheLookListingItem,
        setCompleteTheLookListingItem,
        mainPdpItemQuantity,
        setMainPdpItemQuantity
      }}
    >
      {props.children}
    </NonBedPdpContext.Provider>
  );
};
